<template>
  <div class="diy-guide" :style="'padding:'+itemStyle.paddingTop+'px 0; background:'+itemStyle.background">
    <div class="line" :style="'border-top:'+itemStyle.lineHeight+'px '+itemStyle.lineStyle+' '+itemStyle.lineColor" />
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle"],
  created(){
  },
  activated() {
  },
  methods:{
    
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.diy-guide .line {
  width: 100%;
}
</style>